import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TruncatePipe} from './pipes/TruncatePipe';
import { ModalDetailComponent } from './components/modal-detail/modal-detail.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {
  MatButtonModule, MatCheckboxModule,
  MatDatepickerModule, MatFormFieldModule, MatIconModule, MatInputModule,
  MatSelectModule
} from '@angular/material';
import {ImageCropperModule} from 'ngx-image-cropper';
import {AuthInterceptor} from '../../auth.interceptor';
import {NgxGalleryModule} from 'ngx-gallery';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    InfiniteScrollModule,
    HttpClientModule,
    NgbModule.forRoot(),
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDatepickerModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    ImageCropperModule,
    NgxGalleryModule
  ],
  declarations: [TruncatePipe, ModalDetailComponent],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
  ],
  exports: [
    TruncatePipe,
    ModalDetailComponent
  ]
})
export class ComMonModule { }



// WEBPACK FOOTER //
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/app/pages/common/common.module.ts